import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import Chip, { ChipProps } from './Chip';

const styles = ({
  custom: { fontSizes, palette },
  palette: {
    common: { white },
  },
}: Theme) =>
  createStyles({
    root: {
      color: white,
      fontSize: fontSizes.tiny,
      height: 20,
      textTransform: 'uppercase',
      background: palette.colorAccentAloe,
    },
  });

export interface ChipSuccessProps extends Omit<ChipProps, 'classes'>, WithStyles<typeof styles> {
  label: React.ReactNode;
}

const ChipSuccess: React.FC<ChipSuccessProps> = ({ classes, className, ...rest }) => (
  <Chip className={classnames(classes.root, className)} dense {...rest} />
);

export default withStyles(styles)(ChipSuccess);
